module.exports = __webpack_public_path__ + "static/media/accomodation.a04fb94c.svg";